// src/components/notes/NewNote.js
import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../../context/AuthContext.js';
import './NewNote.css';

export default function NewNote() {
  const navigate = useNavigate();
  const { studentId } = useParams();
  const token = sessionStorage.getItem('jwtToken');
  const { isAuthenticated } = useAuth();

  const [noteDate, setNoteDate] = useState(() => {
    const today = new Date().toISOString().slice(0, 10);
    return today;
  });
  const [content, setContent] = useState('');
  const [error, setError] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  axios.defaults.withCredentials = true;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setError(null);
    try {
      await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/notes/add`,
        { studentId: studentId.trim(), noteDate, content },
        { headers: { Authorization: `Bearer ${token}` }}
      );
      navigate(-1);
    } catch (err) {
      console.error('Error creating note', err);
      setError('Fout bij opslaan, probeer opnieuw.');
    } finally {
      setIsSubmitting(false);
    }
  };

  if (!isAuthenticated) {
    return <p>Je bent niet ingelogd.</p>;
  }

  return (
    <div className="new-note-container">
      <h2>Nieuwe Notitie</h2>
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="noteDate">Datum</label>
          <input
            type="date"
            id="noteDate"
            name="noteDate"
            value={noteDate}
            onChange={(e) => setNoteDate(e.target.value)}
            required
          />
        </div>

        <div className="form-group">
          <label htmlFor="content">Notitie</label>
          <textarea
            id="content"
            name="content"
            rows="6"
            value={content}
            onChange={(e) => setContent(e.target.value)}
            placeholder="Schrijf hier je notitie..."
            required
          ></textarea>
        </div>

        {error && <p className="error-message">{error}</p>}

        <div className="form-actions">
          <button type="button" className="btn-cancel" onClick={() => navigate(-1)} disabled={isSubmitting}>
            Annuleren
          </button>
          <button type="submit" className="btn-submit" disabled={isSubmitting}>
            {isSubmitting ? 'Opslaan...' : 'Opslaan'}
          </button>
        </div>
      </form>
    </div>
  );
}
